import React from "react";
import { Outlet } from "react-router-dom";
const tripComponent = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
export default tripComponent
